import { render } from "./ProductConfig.vue?vue&type=template&id=03d3eef0&scoped=true&ts=true"
import script from "./ProductConfig.vue?vue&type=script&lang=ts"
export * from "./ProductConfig.vue?vue&type=script&lang=ts"

import "./ProductConfig.vue?vue&type=style&index=0&id=03d3eef0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d3eef0"]])

export default __exports__